import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AdminPage from "./pages/Admin"; // Example additional page
import Karte from "./pages/Karte";
import Reservation from "./pages/Reservation";
import Order from "./pages/Order";
import Checkout from "./pages/Checkout";
import background from "./assets/images/welcome.jpeg";
import Login from "./pages/Login";
import Header from "./components/header/header";
import AdminHeader from "./components/admin/header/header";
import Footer from "./components/footer/Footer";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AdminSpeisekarten from "./pages/admin/Menus";
import Settings from "./pages/admin/Settings";

const App = () => {
    return (
        <Router>
            <div className="App flex flex-col min-h-screen">
                <div
                    className="fixed top-0 left-0 w-full h-screen bg-cover bg-center bg-no-repeat -z-10"
                    style={{ backgroundImage: `url(${background})` }}
                >
                    <div className="absolute w-full h-full bg-black bg-opacity-50"></div>
                </div>
                {
                    //Show header if not /admin/*
                    window.location.pathname.includes("admin") ? (
                        <AdminHeader />
                    ) : (
                        <Header />
                    )
                }
                <main className="flex-grow">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/admin" element={<AdminPage />} />
                        <Route
                            path="/admin/speisekarten"
                            element={<AdminSpeisekarten />}
                        />
                        <Route
                            path="/admin/einstellungen"
                            element={<Settings />}
                        />
                        <Route path="/karte" element={<Karte />} />
                        <Route path="/reservierung" element={<Reservation />} />
                        <Route path="/bestellen" element={<Order />} />
                        <Route path="/checkout" element={<Checkout />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/impressum" element={<Impressum />} />
                        <Route path="/datenschutz" element={<Datenschutz />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
            </div>
        </Router>
    );
};

export default App;
